import React from "react";
import { connect } from "react-redux";
import _ from "lodash";

import { useDispatch } from "Hooks/useDispatch";
import {
  getMessagingV2ReduxState,
  setInitAddMemberModalId,
} from "MessagingV2/modules/MessagingModule";
import { isIdEqual } from "Utils/idHelpers";
import ChatToChannel from "MessagingV2/components/ChatToChannel";
import { CHAT_TYPE_ENUM } from "MessagingV2/modules/Utils";

const InitAddMemberModal = props => {
  const {
    chatId,
    channelLabel,
    conversationType,
    users,
    initAddMemberModalId,
  } = props;
  const dispatch = useDispatch();

  const onCloseModal = React.useCallback(() => {
    dispatch(setInitAddMemberModalId(null));
  }, [dispatch]);

  const isDepartmentChannel = _.isEqual(
    CHAT_TYPE_ENUM.CHANNEL_DEPARTMENT,
    conversationType
  );

  const showModal =
    isIdEqual(chatId, initAddMemberModalId) && isDepartmentChannel;

  return showModal ? (
    <ChatToChannel
      onCloseModal={onCloseModal}
      chatId={chatId}
      allSelected={true}
      channelLabel={channelLabel}
      conversationType={conversationType}
      users={users}
    />
  ) : null;
};

const mapStateToProps = state => {
  const messagingState = getMessagingV2ReduxState(state);

  const initAddMemberModalId = _.get(messagingState, "initAddMemberModalId");
  return {
    initAddMemberModalId,
  };
};

export default connect(mapStateToProps)(InitAddMemberModal);
